import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import _ from 'lodash'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { subscribe } from '../../common/users/actions'
import { clearLessonDetail, getUserLessons } from '../../common/lessons/actions'
import { exerciseTypes } from '../../common/config'
import { TextInput, Button, FacebookShare, LessonsList } from '../components'

class SubscribePage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      subscriberEmail: '',
      subscribed: false,
    }
  }

  componentDidCatch(error, info) {
    console.log('error - SubscribePage')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentDidMount() {
    const { getUserLessons, currentLesson } = this.props
    if (currentLesson) {
      const { createdBy } = currentLesson
      getUserLessons(createdBy.id)
    }
  }

  render() {
    const { viewer, currentLesson, clearLessonDetail, creatorLessons, registeringUser, subscribe, intl } = this.props
    const { subscriberEmail } = this.state

    // if (!currentLesson) return null

    return (
      <div className="vocabulary-learn-page vocabulary-learn-page-complete width-full">
        <h3 className="vocabulary-learn-page-complete-title">
          {intl.formatMessage(messages.congratulations)}
        </h3>
				{
          this.state.subscribed ?
            <React.Fragment>
              <p>{intl.formatMessage(messages.subscriptionThanks)}</p>
              <p>
                <FormattedMessage
                  { ...messages.moreUserLessons }
                  values={{ userName: currentLesson.createdBy.name }}
                />
              </p>
              <LessonsList lessons={creatorLessons && creatorLessons.toJS()} />
              <Link to="/first-list?type=list" onClick={() => clearLessonDetail()}>
                <Button positive>
                  {intl.formatMessage(messages.createNewList)}
                </Button>
              </Link>
            </React.Fragment>
					:
						<React.Fragment>
              <p>
                <FormattedMessage
                  { ...messages.subscribeMessage }
                  values={{ wordsCount: currentLesson.words.length }}
                />
              </p>
							<TextInput
								placeholder={intl.formatMessage(messages.subscribePlaceholder)}
								value={subscriberEmail}
								onChange={(e) =>
									this.setState({ subscriberEmail: e.target.value })}
							/>
							<Button
								positive
                className="disable-spacing-left"
								onClick={() => {
									this.setState({ subscriberEmail: '', subscribed: true })
									subscribe({
										email: subscriberEmail,
										lesson: currentLesson && currentLesson.id,
										progress: currentLesson && currentLesson.words.length,
                  })
                  // clearLessonDetail()
								}}
							>
								{intl.formatMessage(messages.subscribeButton)}
							</Button>
						</React.Fragment>
				}
      </div>
    )
  }
}

SubscribePage.defaultProps = {
  currentLesson: null,
  match: null,
  viewer: null,
  registeringUser: null,
  isPopup: false,
  creatorLessons: null,
}

SubscribePage.propTypes = {
  intl: PropTypes.object.isRequired,
  creatorLessons: PropTypes.object,
  subscribe: PropTypes.func.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  getUserLessons: PropTypes.func.isRequired,
  currentLesson: PropTypes.object,
  match: PropTypes.object,
  viewer: PropTypes.object,
  registeringUser: PropTypes.object,
}

SubscribePage = withRouter(SubscribePage)

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    lessons: state.lessons.all,
    currentLesson: state.lessons.currentLesson,
    registeringUser: state.users.registeringUser,
    creatorLessons: state.lessons.publicLessons,
  }), { subscribe, clearLessonDetail, getUserLessons }),
  injectIntl,
)

export default enhance(SubscribePage)

const messages = defineMessages({
	congratulations: {
    id: 'vocabularyLearn.page.congratulations',
    defaultMessage: 'Výborne. Len tak ďalej :)',
  },
  subscribeMessage: {
    id: 'vocabularyLearn.page.subscribeMessage',
    defaultMessage: 'Precvičili ste si {wordsCount} nových slovíčok. Uložte Váš progres. Vložte email a zašleme Vám nové slovíčka.',
  },
  subscribePlaceholder: {
    id: 'vocabularyLearn.page.subscribePlaceholder',
    defaultMessage: 'Vložte Váš email',
  },
  subscribeButton: {
    id: 'vocabularyLearn.page.subscribeButton',
    defaultMessage: 'Odoslať',
  },
  subscriptionThanks: {
    id: 'vocabularyLearn.page.subscriptionThanks',
    defaultMessage: 'Ďakujeme!',
  },
  moreUserLessons: {
    id: 'vocabularyLearn.page.moreUserLessons',
    defaultMessage: 'Zoznamy slovíčok užívateľa {userName}:',
  },
  createNewList: {
    id: 'vocabularyLearn.page.createNewList',
    defaultMessage: 'Vytvoriť vlastný zoznam slovíčok',
  },
  
})



// WEBPACK FOOTER //
// ./src/browser/pages/SubscribePage.js